import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    effect, EventEmitter,
    Input,
    OnChanges,
    OnInit, Output,
    ViewChild
} from '@angular/core';
import {NgClass} from "@angular/common";
import {SectionModel} from "@white-label/components/page-builder/models/section.model";
import {TranslateModule} from "@ngx-translate/core";
import {FadeInOnScrollDirective} from "@cybfed/core/helpers/fade-in-on-scroll.directive";
import {CdkDragHandle} from "@angular/cdk/drag-drop";
import {PageBuilderStore} from "@white-label/components/page-builder/page-builder.store";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {VideoPlayerComponent} from "@white-label/components/white-label/video-player/video-player.component";

@Component({
    selector: 'app-section-component',
    standalone: true,
    imports: [
        NgClass,
        TranslateModule,
        FadeInOnScrollDirective,
        CdkDragHandle,
        VideoPlayerComponent
    ],
    providers: [
    ],
    templateUrl: './section.component.html'
})
export class SectionComponent implements OnInit, OnChanges {
    @Input() componentData?: any =  new SectionModel();
    @Input() editMode: boolean = true;
    @Input() index: any = 0;
    @Output() removeSection: EventEmitter<any> = new EventEmitter();
    @ViewChild('videoPlayer') video?: HTMLVideoElement;

    constructor(public pageBuilderStore: PageBuilderStore,
                public mainStore: MainStoreService,
                private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {

    }
    ngOnChanges(): void {
        // Manually trigger change detection when @Input() changes
        this.cdr.markForCheck();
    }

    selectComponentForEdit() {
        this.pageBuilderStore.configurationTab = 'component-configuration';
        this.pageBuilderStore.sectionData = this.componentData
        this.pageBuilderStore.componentData = this.componentData.data
        this.pageBuilderStore.index = this.index;

        this.pageBuilderStore.sideBarIsOpen = true;

    }

    deleteComponent(index: number): void {
        let removeIndex = this.pageBuilderStore.page.sections.findIndex((item:any) => item.sortOrder === index);
        this.pageBuilderStore.page.sections.splice(removeIndex, 1);
        this.pageBuilderStore.sectionData = null;
        this.pageBuilderStore.componentData = null;
        this.pageBuilderStore.configurationTab = 'seo-configuration';
        this.removeSection.emit(removeIndex);
    }


}
